import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';

const useCreateDiscount = () => {
  const path = API_ENDPOINTS.DISCOUNTS;
  const { t } = useTranslation(LOCALIZATION_PAGES.DISCOUNTS);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, createDiscount] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('discount_create_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('discount_create_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading, error }, createDiscount];
};

export default useCreateDiscount;
